import { i18nResource } from "../../i18nResource.interface";

const section4: i18nResource.Section4 = {
    title1_1: "META ADVENTURE ",
    title1_2: "NFT ",
    title1_3: "COLLECTIONS",
};

export default section4;
